export default "__VITE_ASSET__DLQ4t1Ge__"